import React from "react";
import SEO from "../components/seo";
import ContentPage from "../components/content-page";
var JobsPage = function JobsPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: data.datoCmsJobSite.title
    }), /*#__PURE__*/ React.createElement(ContentPage, {
        title: data.datoCmsJobSite.title,
        content: data.datoCmsJobSite.text
    }));
};
var query = "2256270663";
export default JobsPage;
